<template lang="">
  <base-link
    v-if="product"
    class="row border border-light-subtle p-2 mx-0 mb-2"
    :to="product.url"
  >
    <div class="product-cover text-center p-1">
      <lazy-image
        :src="product.image"
        :alt="product.name || undefined"
        width="80"
        height="80"
      />
    </div>
    <div class="text-center">
      <h6 class="suggestion-product-name">
        <safe-html
          class="text-secondary fs-7 line-clamp-2"
          :html="product.name"
        />
      </h6>
      <div>
        <safe-html
          class="text-blue fw-semibold fs-5"
          :html="formatPrice(product.current_price_with_tax)"
        />
      </div>
    </div>
  </base-link>
</template>

<script lang="ts">
import BaseLink from "~/components/buttons/BaseLink.vue";
import { getFinalEshopUrl } from "@/utils/general";
import eventBus from "~/event-bus";
import SafeHtml from "../utils/SafeHtml.vue";
import LazyImage from "../utils/LazyImage.vue";

export default {
  components: {
    BaseLink,
    SafeHtml,
    LazyImage,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  emits: ["close-suggestions"],
  methods: {
    getFinalUrl(path: string) {
      return getFinalEshopUrl(path);
    },
    goToProductDetail(path: string) {
      eventBus.emit("close-suggestions");
      return this.$router.push(path);
    },
  },
};
</script>

<style>
.product-cover {
  img {
    object-fit: contain;
  }
}
.suggestion-product-name em {
  font-weight: bold;
  color: #d93d0e;
}
</style>
